import React, { FC } from 'react';
import Military from '@components/profile/profileOverlay/overlays/militaryPreference/preferentialWrite/militaryForm/Military';

import styles from '../../militaryPreference.module.scss';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const MilitaryForm: FC = () => {
  const fieldName = 'military';

  return (
    <div className={cx('infoArea', 'military')}>
      <Military prefixName={fieldName} />
    </div>
  );
};

export default MilitaryForm;
